// extracted by mini-css-extract-plugin
export default {"main":"Home_main__GEmU6","btnprimary":"Home_btnprimary__NMsL5"};